/* eslint-disable security/detect-object-injection */
/* eslint-disable max-len */
// idSlice.js
import { createSlice } from '@reduxjs/toolkit';


const initialState={
    selectedFilterProvider:{
        data:[],
        selectedArr:[], 
        unselectedArr:[],
        isCheckedUsersAll:true,
        searchVal:'',
        totalUsers:0
        
    }
    
}
const wellnessProviderSlice = createSlice({
    name: 'selectedFilterProvider',
    initialState: initialState,
    reducers: {
     
        toggleRowSelection: (state, action) => {
            let column=action.payload[0]
            const dataItems=action?.payload[1]?.map(item=>item._id)
            const selectAllofSearchOrCompleteList = action?.payload[2]
            const complete_list_or_searched_list = action?.payload[3]
            const isChecked = action?.payload[4]
            if(isChecked){
                if((complete_list_or_searched_list==='complete_list'&&!selectAllofSearchOrCompleteList)||(complete_list_or_searched_list==='searched_list'&&!selectAllofSearchOrCompleteList)){
                    state.selectedFilterProvider.unselectedArr.includes(column)?state.selectedFilterProvider.unselectedArr=state.selectedFilterProvider?.unselectedArr?.filter(item=>item!==column):''
                    state.selectedFilterProvider.selectedArr.push(column)
                }else if((complete_list_or_searched_list==='complete_list'&&selectAllofSearchOrCompleteList)||(complete_list_or_searched_list==='searched_list'&&selectAllofSearchOrCompleteList)){
                    state.selectedFilterProvider.unselectedArr.includes(column)?state.selectedFilterProvider.unselectedArr=state.selectedFilterProvider.unselectedArr.filter(item=>item!==column):''
                    state.selectedFilterProvider.selectedArr.push(column)
                }
            }
            
            else{
                if((complete_list_or_searched_list==='complete_list'&&!selectAllofSearchOrCompleteList)||(complete_list_or_searched_list==='searched_list'&&!selectAllofSearchOrCompleteList)){
                    state.selectedFilterProvider.selectedArr.includes(column)?state.selectedFilterProvider.selectedArr=state.selectedFilterProvider?.selectedArr?.filter(item=>item!==column):''
                    state.selectedFilterProvider.unselectedArr.push(column)
                }else if((complete_list_or_searched_list==='complete_list'&&selectAllofSearchOrCompleteList)||(complete_list_or_searched_list==='searched_list'&&selectAllofSearchOrCompleteList)){
                    state.selectedFilterProvider.selectedArr.includes(column)?state.selectedFilterProvider.selectedArr=state.selectedFilterProvider.selectedArr.filter(item=>item!==column):''
                    state.selectedFilterProvider.unselectedArr.push(column)
                }
                
            }
            if(complete_list_or_searched_list==='complete_list'){
                if(state.selectedFilterProvider.selectedArr.length===0&&state.selectedFilterProvider.unselectedArr.length===0||(state.selectedFilterProvider.selectedArr.length===state.selectedFilterProvider.totalUsers)){
                    state.selectedFilterProvider.isCheckedUsersAll=true
                }else{
                    state.selectedFilterProvider.isCheckedUsersAll=false
                }
            }else if(complete_list_or_searched_list==='searched_list'){
                if((dataItems?.every(item=>state.selectedFilterProvider.selectedArr.includes(item)))&&(!dataItems.some(item=>state.selectedFilterProvider.unselectedArr.includes(item)))||(action.payload[5]===true&&(!dataItems.some(item=>state.selectedFilterProvider.unselectedArr.includes(item))))){
                    state.selectedFilterProvider.isCheckedUsersAll=true
                } else{
                    state.selectedFilterProvider.isCheckedUsersAll=false
                }
            }
            

        },
        selectAllUserRows:(state,action)=>{
            // if(action.payload[0]===false){
            //     state.selectedFilterProvider.selectedArr=state.selectedFilterProvider.selectedArr.filter(
            //         (element) => !action.payload[1]?.map((item)=>item?._id).includes(element)
            //     );
            //     state.selectedFilterProvider.isCheckedUsersAll=false
            // }
            // else{
            //     const newData = action.payload[1]?.map((item) => item?._id);

            //     // Filter out elements that already exist in state.selectedFilterProvider.selectedArr[index]
            //     const uniqueData = newData.filter((item) => !state.selectedFilterProvider.selectedArr.includes(item));
            //     // state.selectedFilterProvider.selectedArr[index].push(action.payload[1]?.data?.map((item)=>item?.user_id))
            //     state.selectedFilterProvider.selectedArr.push(...uniqueData)
            //     state.selectedFilterProvider.isCheckedUsersAll=true
            // }
            state.selectedFilterProvider.isCheckedUsersAll=action.payload[0]
            const dataItems= action.payload[1]?.map(item=>item._id)
            const searchedItem = action.payload[2]
            if(searchedItem?.trim()===''){
                state.selectedFilterProvider.selectedArr=[]
                state.selectedFilterProvider.unselectedArr=[]
            }else{
                if(action.payload[0]===false){
                    state.selectedFilterProvider.selectedArr?.length>0? state.selectedFilterProvider.selectedArr = state.selectedFilterProvider.selectedArr.filter(item=> !dataItems.includes(item)):''
                    let newArr= new Set([...state.selectedFilterProvider.unselectedArr, ...dataItems])
                    state.selectedFilterProvider.unselectedArr = [...newArr]
                }else if (action.payload[0]===true){
                    let newArr = new Set([...state.selectedFilterProvider.selectedArr, ...dataItems]);
                    state.selectedFilterProvider.selectedArr = [...newArr]
                    state.selectedFilterProvider.unselectedArr?.length>0? state.selectedFilterProvider.unselectedArr = state.selectedFilterProvider.unselectedArr.filter(item=> !dataItems.includes(item)):''
                }
                
            }
           
 
        },
     
        
        searchReducer:(state,action)=>{
            // const allExistMethod1 = action?.payload[0]?.every((item2) =>
            //     state.selectedFilterProvider.selectedArr?.some((item1) => item1 === item2._id)
            // )
            // if(allExistMethod1){
            //     state.selectedFilterProvider.isCheckedUsersAll=true
            // }
            // else{
            //     state.selectedFilterProvider.isCheckedUsersAll=false
            // }
            const dataItems=action?.payload[0]?.map(item=>item._id)
            const selectAllofSearchOrCompleteList = action?.payload[1]
            const selectAllofSearch= action?.payload[2]
            const complete_list_or_searched_list = action?.payload[3]
            if(complete_list_or_searched_list==='complete_list'){
                if((selectAllofSearchOrCompleteList&&state.selectedFilterProvider.unselectedArr.length===0&&action.payload[4]!=='empty')||(state.selectedFilterProvider.selectedArr.length===state.selectedFilterProvider.totalUsers&&action.payload[4]!=='empty')){
                    state.selectedFilterProvider.isCheckedUsersAll=true
                }else{
                    state.selectedFilterProvider.isCheckedUsersAll=false
                }
            }else{
                if((dataItems.every(item => state.selectedFilterProvider.selectedArr.includes(item))||(selectAllofSearchOrCompleteList&&!(dataItems.some(item=>state.selectedFilterProvider.unselectedArr.includes(item)))))){
                    state.selectedFilterProvider.isCheckedUsersAll=true
    
                }else{
                    state.selectedFilterProvider.isCheckedUsersAll=false
                }
            }
           

            
        },
        handleTotalUsers:(state,action) => {
            state.selectedFilterProvider.totalUsers = action.payload[0]
        },
       
        resetOrgList:(state)=>{
            state.selectedFilterProvider.selectedArr=[], 
            state.selectedFilterProvider.isCheckedUsersAll=true,
            state.selectedFilterProvider.data=[],
            state.selectedFilterProvider.unselectedArr=[],
            state.selectedFilterProvider.searchVal='',
            state.selectedFilterProvider.totalUsers=0
   

        },
        handleFillFromSearchParamsProviders:(state,action) => {
            state.selectedFilterProvider.selectedArr= action.payload[0]
            state.selectedFilterProvider.unselectedArr=action.payload[1]
        },
        resetTempFilterProviderOpen:(state)=>{
            state.selectedFilterProvider.selectedArr=[], 
            state.selectedFilterProvider.isCheckedUsersAll=true,
            state.selectedFilterProvider.unselectedArr=[]
        },
        handleEmptyProviderDropdown:(state)=>{
            state.selectedFilterProvider.isCheckedUsersAll=false,
            state.selectedFilterProvider.selectedArr=[],
            state.selectedFilterProvider.unselectedArr=[]
        }
       

    }
});

export const { handleEmptyProviderDropdown,handleFillFromSearchParamsProviders,resetTempFilterProviderOpen,resetOrgList,searchReducer,toggleRowSelection,selectAllUserRows,handleTotalUsers} = wellnessProviderSlice.actions;
export default wellnessProviderSlice.reducer;
